import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { t } from '@nextcloud/l10n'
import IconOctagonOutline from 'vue-material-design-icons/OctagonOutline.vue'
import EmptyView from '../components/EmptyView.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'ForbiddenView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(EmptyView, {
    name: _unref(t)('spreed', 'You do not have permissions to access this conversation.'),
    description: _unref(t)('spreed', 'Join a different conversation or start a new one.')
  }, {
    icon: _withCtx(() => [
      _createVNode(IconOctagonOutline)
    ]),
    _: 1
  }, 8, ["name", "description"]))
}
}

})